import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap, timeout, map, catchError } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { BBResponseContainer } from '../common-services/response-container';
import { throwError } from 'rxjs/internal/observable/throwError';

@Injectable()
export class ArticDeliveryPlanningService {
  
  defaultTimeout = 600000;
  
  constructor(private http: HttpClient) {
  }
  
  getBatchesForLab(labId: string, fromDate: string): Observable<any> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/deliveryPlanning/list";
      let requestParam = new HttpParams().set('lab', labId).set('date', fromDate);
      const options = url ? { params: requestParam } : {};
    return this.http.get<any>(url, options).pipe(timeout(environment.defaultTimeout), tap(resp=>{resp.url='batches'}));
  }

  updateBatchesForLab(labId: string, currentDate:string, batcheIds: string[], puid: string): Observable<any> {
    let headers = {
      headers: new HttpHeaders({
        'puid': puid
      })};
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/deliveryPlanning/updateBatches/"+labId+"/"+currentDate;
    return this.http.put<BBResponseContainer>(url, batcheIds, headers).pipe(timeout(environment.defaultTimeout), tap(error => {
      error.url = url;
    }));
  }

  getFilesFromAzure(): Observable<any> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/deliveryPlanning/getFilesFromAzure";
    return this.http.get<any>(url).pipe(timeout(environment.defaultTimeout), tap(resp=>{resp.url='batches'}));
  }

  downloadFile(fileName: string){
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + '/covid19Batch/deliveryPlanning/downloadFiles/'+fileName;
    return this.http.get(url, { observe: 'response', responseType: 'blob' }).pipe(
      map((res) => {
        return res;
      }), catchError(error => throwError(error.message))
    );
  }
 }